import React, { FC } from "react";
import { Draggable } from "react-beautiful-dnd";
import styles from "../styles/WorkOrderDNDItem.module.scss";
import useReportsInnerPages from "Containers/Reports/ReportsInnerPages/useReportsInnerPages/useReportsInnerPages";
import { DashboardWorkOrderData } from "Shared/Types/dashboard";

interface WorkOrderDNDDraggableProps {
  workOrderItem: DashboardWorkOrderData;
  index: number;
  navigate: (id: string) => void;
}

export const WorkOrderDNDDraggable: FC<WorkOrderDNDDraggableProps> = ({
  workOrderItem,
  index,
  navigate,
}) => {
  const { fullNameConvertor } = useReportsInnerPages();

  return (
    <Draggable draggableId={workOrderItem.id} index={index}>
      {(provided) => (
        <div
          onClick={() => navigate(workOrderItem.id)}
          className={styles.wrapper__item__dndItem}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <div className={styles.wrapper__item__dndItem__header}>
            <h2 className={styles.wrapper__item__dndItem__header__text}>
              Work Order
            </h2>
            <h3 className={styles.wrapper__item__dndItem__header__text}>
              # {workOrderItem.reference_code || 0}
            </h3>
          </div>
          <h4 className={styles.vehicleName}>{workOrderItem.vehicle_name}</h4>
          <div className={styles.groupWrapper}>
            <span className={styles.groupDetail}>Issue Date:&nbsp;</span>
            <h5 className={styles.groupInfo}>{workOrderItem.issue_date}</h5>
          </div>
          <div className={styles.groupWrapper}>
            <span className={styles.groupDetail}>Driver:&nbsp;</span>
            <h5 className={styles.groupInfo}>
              {fullNameConvertor(
                workOrderItem.driver_first_name,
                workOrderItem.driver_last_name,
              )}
            </h5>
          </div>
          <div className={styles.groupWrapper}>
            <span className={styles.groupDetail}>Subtotal:&nbsp;</span>
            <h5 className={styles.groupInfo}>{workOrderItem.total_cost}</h5>
          </div>
        </div>
      )}
    </Draggable>
  );
};
